export default "__VITE_ASSET__791ad154__"